import * as Types from '../../generated.types'

import { AddressFragmentDoc } from '../../fragments/AddressFragment_gen'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { fetchGql } from '@alice-financial/api'
export type EmployeeQueryVariables = Types.Exact<{ [key: string]: never }>

export type EmployeeQuery = {
  __typename?: 'Query'
  employee?: {
    __typename?: 'Employee'
    id: number
    tosAcceptedAt?: string | null
    role: Types.EmployeeRole
    employmentStartDate?: string | null
    enrollmentInfo: { __typename?: 'EmployeeEnrollment'; enrollmentDate?: string | null }
    spendingInfo: {
      __typename?: 'SpendingInfo'
      hasRecentAutoConfirmedTxns: boolean
      totalEstimatedPretaxSavings?: number | null
    }
    mailingAddress?: {
      __typename?: 'AddressDisplay'
      isVerified: boolean
      isMailing: boolean
      line1?: string | null
      line2?: string | null
      cityName?: string | null
      stateCode?: string | null
      zipcode?: string | null
    } | null
    employer: {
      __typename?: 'Employer'
      id: number
      name?: string | null
      marketingFriendlyName?: string | null
      inviteCode: string
      offboardingDate?: string | null
      organization?: {
        __typename?: 'Organization'
        id: number
        name?: string | null
        aliceCardProgram: { __typename?: 'AliceCardProgram'; cardIssuingStatus: Types.AliceCardIssuingStatus }
      } | null
    }
  } | null
}

export type EmployeeFragment = {
  __typename?: 'Employee'
  id: number
  tosAcceptedAt?: string | null
  role: Types.EmployeeRole
  employmentStartDate?: string | null
  enrollmentInfo: { __typename?: 'EmployeeEnrollment'; enrollmentDate?: string | null }
  spendingInfo: {
    __typename?: 'SpendingInfo'
    hasRecentAutoConfirmedTxns: boolean
    totalEstimatedPretaxSavings?: number | null
  }
  mailingAddress?: {
    __typename?: 'AddressDisplay'
    isVerified: boolean
    isMailing: boolean
    line1?: string | null
    line2?: string | null
    cityName?: string | null
    stateCode?: string | null
    zipcode?: string | null
  } | null
  employer: {
    __typename?: 'Employer'
    id: number
    name?: string | null
    marketingFriendlyName?: string | null
    inviteCode: string
    offboardingDate?: string | null
    organization?: {
      __typename?: 'Organization'
      id: number
      name?: string | null
      aliceCardProgram: { __typename?: 'AliceCardProgram'; cardIssuingStatus: Types.AliceCardIssuingStatus }
    } | null
  }
}

export const EmployeeFragmentDoc = `
    fragment Employee on Employee {
  id
  tosAcceptedAt
  role
  enrollmentInfo {
    enrollmentDate
  }
  employmentStartDate
  spendingInfo {
    hasRecentAutoConfirmedTxns
    totalEstimatedPretaxSavings
  }
  mailingAddress {
    ...Address
  }
  employer {
    id
    name
    marketingFriendlyName
    inviteCode
    offboardingDate
    organization {
      id
      name
      aliceCardProgram {
        cardIssuingStatus
      }
    }
  }
}
    `
export const EmployeeDocument = `
    query Employee {
  employee {
    ...Employee
  }
}
    ${EmployeeFragmentDoc}
${AddressFragmentDoc}`
export const useEmployeeQuery = <TData = EmployeeQuery, TError = Error>(
  variables?: EmployeeQueryVariables,
  options?: UseQueryOptions<EmployeeQuery, TError, TData>
) =>
  useQuery<EmployeeQuery, TError, TData>(
    variables === undefined ? ['Employee'] : ['Employee', variables],
    fetchGql<EmployeeQuery, EmployeeQueryVariables>(EmployeeDocument, variables),
    options
  )

useEmployeeQuery.getKey = (variables?: EmployeeQueryVariables) =>
  variables === undefined ? ['Employee'] : ['Employee', variables]
